import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { AppData } from 'src/app/app.data';
import { Settings } from 'src/app/app.settings.model';
import { Utils } from 'src/app/core/utils';
import { map } from 'rxjs/operators';
import { TreatmentModel } from 'src/app/core/models/treatment-model';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';

@Injectable({
  providedIn: 'root'
})
export class TreatmentService {

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint();

  constructor(private http: HttpClient,
    private router: Router,
    private appSettings: AppSettings,
    private appData: AppData) {

    this.settings = appSettings.settings;
  }

  getTreatmentByID(treatmentID: number) {
    return this.http.get<any>(this.apiEndPoint + `TreatmentApi/GetTreatmentByID/${treatmentID}`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  canTransferAvailableBalanceForTreatment(treatmentID: number){
    return this.http.get<any>(this.apiEndPoint + `TreatmentApi/CanTransferAvailableBalanceForTreatment/${treatmentID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  updateTreatmentStatus(treatmentID: number, treatmentStatusID: number, branchId:number, updatePaid?:boolean){
    const model = {
      TreatmentID: treatmentID,
      TreatmentStatusID: treatmentStatusID,
      BranchID: branchId,
      UpdatePaid: updatePaid
    };
    
    return this.http.post<any>(this.apiEndPoint + `TreatmentApi/ChangeTreatmentStatus`, JSON.stringify(model))
      .pipe(map(result => {
        return result;
      }));
  }

}
